// تحديث 74: أدوات وصول مشتركة (تدقيق web-design-guidelines) — بلا أي تغيير في المنطق
// صف/عنصر قابل للنقر يصبح قابلاً للتركيز ويعمل بالكيبورد (Enter / Space) — يتجاهل الأحداث الصادرة من عناصر داخله
export const keyActivate = (fn) => ({
  tabIndex: 0,
  onKeyDown: (e) => {
    if (e.target !== e.currentTarget) return;
    if (e.key === "Enter" || e.key === " ") { e.preventDefault(); fn(e); }
  },
});

// طبقة تحسين وصول خفيفة تعمل مرة واحدة للتطبيق: تُخفي الأيقونات الزخرفية عن قارئ الشاشة
// وتُسمّي الحقول التي بلا تسمية من (placeholder / أول خيار / title) دون لمس أي مكوّن.
export function installA11yEnhancer() {
  if (typeof window === "undefined" || window.__asfA11y) return;
  window.__asfA11y = true;
  let queued = false;
  const run = () => {
    queued = false;
    document.querySelectorAll('i[class*="fa-"]:not([aria-hidden]), svg.lucide:not([aria-hidden])').forEach((el) => el.setAttribute("aria-hidden", "true"));
    document.querySelectorAll("input:not([type=hidden]):not([type=file]):not([aria-label]):not([aria-labelledby]), select:not([aria-label]):not([aria-labelledby]), textarea:not([aria-label]):not([aria-labelledby])").forEach((el) => {
      if (el.closest("label") || (el.id && document.querySelector(`label[for="${CSS.escape(el.id)}"]`))) return;
      let name = el.getAttribute("title") || el.getAttribute("placeholder") || "";
      if (!name && el.tagName === "SELECT") name = el.options?.[0]?.text || "";
      name = name.replace(/…|\.{3}$/, "").trim();
      if (name) el.setAttribute("aria-label", name);
    });
  };
  const schedule = () => { if (!queued) { queued = true; (window.requestAnimationFrame || setTimeout)(run); } };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
}
